<loading-overlay [show]="busy">
    <div class="row me-0" style="margin-top: 5%">
        <div class="col-sm-3">
        </div>
        <div class="col-sm-6">
            <div class="card text-center">
                <div class="card-body">
                    <h1 class="card-title" style="font-size: large; font-weight:600;">FBI-Home</h1>
                    <google-login>
                    </google-login>
                </div>
            </div>
        </div>
        <div class="col-sm-3">
        </div>
    </div>
</loading-overlay>

<modal-dialog #modalDialog [showCloseButton]="true" [ngStyle]="{'min-width': '60%', 'width': '60%'}"
    [title]="'Error de acceso'">
    <ng-container>

        <div class="row">
            <div class="col-sm-12">
                <div class="card text-center login-modal-error">
                    <h2>{{errorUserDataMsg}}</h2>
                </div>
            </div>
        </div>

    </ng-container>
</modal-dialog>